module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jenna Mindel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jenna Mindel lives in Northwest Lower Michigan with her husband and their two dogs. A 2006 Romance Writers of America Rita award finalist, Jenna writes inspirational romances set near the Great Lakes."), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BRYoEJ/tc-custom/9781426885297.jpg?1724855613246",
      "alt": "This image is the cover for the book Season of Dreams"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Season of Dreams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Opposites attract when a small town woman agrees to help a city man run her family cherry orchard and falls in love with him in this inspirational romance.")]), _c('br'), _c('br'), _vm._v("Longing for a simpler life, wealthy businessman Adam Peece buys a cherry orchard in Michigan. Problem is, he has no idea how to run it! So he asks Eva Marsh to teach him the ropes. Cherries are in Eva’s blood. Her family owned the orchard for generations before selling it to Adam. But she doesn’t trust people easily, especially tall, dark and handsome city slickers. However, one look into Adam’s caring eyes convinces her to give the city boy a chance. Could their working relationship blossom into love before season’s end?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0